import _ from "lodash";
import { mapActions, mapGetters, mapMutations } from "vuex";
import navigateTo from "../../../mixins/buy-flow";
import typeSelect from "./components/select/index.vue";
import { formatPrice, getProductPriceTitle, resolveProductImage, routeToProduct } from "@/helpers";
import togetherSlider from "./components/together-slider/index.vue";
import { debounce } from "lodash";

export default {
  name: "basket",
  mixins: [navigateTo],
  data() {
    return {
      selectedProductPrice: {},
      productsKey: 1,
    };
  },

  watch: {
    $route: function () {
      document.getElementById("html").classList.remove("hide");
      this.changeBasketPopup(false);
    },
  },
  components: {
    typeSelect,
    togetherSlider,
  },

  computed: {
    ...mapGetters({
      saleProducts: "order/saleProducts",
      isAuthenticated: "auth/isAuthenticated",
      user: "profile/user",
      buyTogetherProducts: "basket/buyTogetherProducts",
      basket: "basket/basket",
      giftGroups: "order/giftGroups",
      selectedGifts: "order/selectedGifts",
      earnedGiftCount: "order/earnedGiftCount",
      hasUnselectedGifts: "order/hasUnselectedGifts",
      samplerProducts: "order/samplerProducts",
    }),
    priceType() {
      return this.bonusesAmount > 0 ? 'basePrice' : 'price'
    },
    selectedGiftPreview() {
      const rows = [];
      this.selectedGifts.forEach(item => {
        const group = this.giftGroups.find(g => g.id === item.giftGroupId);
        if (!group) return;
        const variant = group.products.find(v => v.productPriceId === item.productPriceId);
        if (!variant) return;
        const price = variant.product?.productPrices?.data?.find(
          p => p.id === variant.productPriceId
        );
        rows.push({
          ...item,
          title: variant.product.title,
          image: price?.image || variant.productImage || variant.product.image,
        });
      });
      return rows;
    },
    promotionalProducts() {
      return this.buyTogetherProducts.map(product => ({
          ...product,
          productPrices: {
            data: product.productPrices.data.sort((a, b) => (a.value > b.value ? -1 : 1)),
          },
        }));
    },
    totalSum() {
      return _.sumBy(this.basket, product => product.select_type[this.priceType] * product.select_count);
    },
    getTempDiscount() {
      return this.hasTempDiscount() ? (this.totalSum * 5) / 100 : 0;
    },
  },
  created() {
    document.getElementById("html").classList.add("hide");
    this.getBuyTogetherProducts();
    this.checkOrderGift();
  },
  methods: {
    formatPrice,
    routeToProduct,
    getProductPriceTitle,
    resolveProductImage,
    ...mapMutations({
      increment: "basket/INCREMENT_BASKET_LIST_COUNT",
      decrement: "basket/DECREMENT_BASKET_LIST_COUNT",
      setCount: "basket/SET_BASKET_LIST_COUNT",
      remove: "basket/REMOVE_ITEM_FROM_BASKET",
      changeBasketPopup: "basket/SHOW_BASKET_POPUP",
      changeLoginPopup: "popups/CHANGE_LOGIN_POPUP",
      changeSelectGiftPopup: "popups/CHANGE_SELECT_GIFT_POPUP",
      addToBasket: `basket/ADD_ITEM_TO_BASKET`,
      morphBasket: "basket/MORPH_BASKET",
    }),
    ...mapActions({
      getSyncBasket: "basket/GET_SYNC_BASKET",
      fetchBuyTogetherProducts: "basket/GET_BUY_TOGETHER_PRODUCT",
      checkSale: "order/CHECK_SALE",
      checkGift: "order/CHECK_GIFT",
      checkSampler: "order/CHECK_SAMPLER",
    }),
    /** @param {Product} product */
    addBasket(product) {
      let sorted = product.productPrices.data.sort(this.compare);
      let selectedProductPrice = sorted[1] ? sorted[1] : sorted[0];
      this.productsKey += 1;

      if (product.hasDuplicate) {
        this.$toasted.info("Цей товар переміщено до нової серії");
        return;
      }

      this.addToBasket({
        select_count: 1,
        product_price: selectedProductPrice,
        product: product,
        unauthorizedProductPriceId: this.product.unauthorizedProductPriceId,
      });
      // eslint-disable-next-line no-undef
      fbq("track", "AddToCart", {
        content_type: "product",
        currency: "UAH",
        value: selectedProductPrice.price,
        content_name: product.title,
        content_ids: product.unauthorizedProductPriceId,
        content_category: product.brandSeries?.title || product.brand?.title || product.title,
      });
    },

    async runCheckOrderGift() {
      try {
        let products = {};
        this.basket.map(item => {
          products[item.select_type.id] = item.select_count;
        });

        const formattedProducts = Object.fromEntries(
          Object.entries(products).map(([key, value]) => [`products[${key}]`, value])
        );
        await Promise.all([
          this.checkGift(formattedProducts),
          this.checkSampler(formattedProducts),
          this.checkSale(formattedProducts),
        ]);
        this.morphBasket(this.saleProducts);
      } catch (e) {
        console.error(e);
      }
    },
    checkOrderGift: debounce(function () {
      return this.runCheckOrderGift();
    }, 500),

    async sync() {
      const products = this.basket.map(basketItem => {
        return {
          id: basketItem.id,
          select_count: basketItem.select_count,
        }
      })
      await this.getSyncBasket(products);
    },

    getLargeValue(products) {
      return products[0];
    },
    closePopup() {
      document.getElementById("html").classList.remove("hide");
      this.changeBasketPopup(false);
    },
    toProduct() {
      document.getElementById("html").classList.remove("hide");
      this.changeBasketPopup(false);
    },
    async goToOrder() {
      await this.runCheckOrderGift();
      if (this.hasUnselectedGifts) {
        this.changeSelectGiftPopup(true);
        return;
      }
      document.getElementById("html").classList.remove("hide");
      this.changeBasketPopup(false);
      this.navigateTo("buy-flow-order");
    },
    hasTempDiscount() {
      return this.user && this.user.tempDiscount;
    },
    async removeProduct(item) {
      this.remove(item);
      await this.runCheckOrderGift();
    },
    /**
     *
     * @param {string} type
     * @param count
     * @param {BasketProduct} basketProduct
     */
    async changeCount(type, count = 1, basketProduct) {
      if (type === "increment") {
        this.increment(basketProduct);
      } else if (type === "decrement") {
        this.decrement(basketProduct);
      } else {
        if (count) {
          this.setCount({
            product: basketProduct,
            select_count: parseInt(count),
          });
        }
      }
      await this.checkOrderGift();
    },
    async getBuyTogetherProducts() {
      await this.fetchBuyTogetherProducts({ ids: _.map(this.basket, "id") });
    },
  },
};
